
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from 'next/head';
import BasePageLayout from '#layouts/BasePageLayout/BasePageLayout';
import { staticTitle } from '#config';
import { useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import IllustratedLayout from '#components/layout/IllustratedLayout';
import Typography from '#components/typography/Typography';
import Button from '#components/controls/button/Button';
import { reportServerErrorPage } from '#utils/dd';

const Custom500 = ({ message }) => {
  const { t } = useTranslation();

  useEffect(() => {
    reportServerErrorPage(message);
  }, [message]);

  return (
    <BasePageLayout hasCanonical={false}>
      <Head>
        <title>
          {staticTitle}
          {t('pageErrorTitle500')}
        </title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <main className="page-main-container has-bg-gradient">
        <IllustratedLayout
          title={t('pageErrorTitle500')}
          verticalAlignContent="center"
          image="/static/images/img/edda-hex.png"
          content={
            <div className="tw-flex-col">
              <Typography
                dangerouslySetInnerHTML={{
                  __html: t('pageErrorDescription500'),
                }}
              />
              {!!message && <Typography>Ref: {message}</Typography>}
              <Button
                title={t('pageErrorButtonText500')}
                color="secondary"
                href="/"
                target="_self"
                classes="tw-mt-16"
              />
            </div>
          }
        />
      </main>
    </BasePageLayout>
  );
};

export default Custom500;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/500',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  